import React, { useState } from 'react'
import { useStripe } from '@stripe/react-stripe-js';
import StripeACHAccountHolderForm from './StripeACHAccountHolderForm';
import StripeACHPaymentConfirmationForm from './StripeACHPaymentConfirmationForm';

const StripeACH = ({ onSuccess }) => {
    const stripe = useStripe();

    const [clientSecret, setClientSecret] = useState(undefined);
    const [bankAccountDetails, setBankAccountDetails] = useState({});

    return (
        <>
            {
                !clientSecret && (
                    <StripeACHAccountHolderForm
                        stripe={stripe}
                        setBankAccountDetails={setBankAccountDetails}
                        setClientSecret={setClientSecret} />
                )
            }
            {
                clientSecret && (
                    <StripeACHPaymentConfirmationForm
                        stripe={stripe}
                        bankAccountDetails={bankAccountDetails}
                        setBankAccountDetails={setBankAccountDetails}
                        clientSecret={clientSecret}
                        setClientSecret={setClientSecret}
                        onSuccess={onSuccess} />
                )
            }
        </>
    )
}

export default StripeACH
